import { alphaSort } from 'vet-bones/utils';

import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';

export const getProjectAttributesByDomain = (
  attributesByIri: Record<string, ModelConceptAttribute>
) =>
  Object.values(attributesByIri).reduce<
    Record<string, ModelConceptAttribute[]>
  >((acc, attribute) => {
    Object.values(attribute.domains).forEach(({ value }) => {
      acc[value] = [...(acc[value] || []), attribute].sort(
        alphaSort((item) => item.value)
      );
    });
    return acc;
  }, {});
